import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';

const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
];

export default function LanguageSwitcher({ variant = 'default' }) {
  const { i18n } = useTranslation();
  const current = LANGS.find(l => l.code === i18n.language) || LANGS[0];

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`gap-1.5 ${variant === 'nav' ? 'text-[#5C6656] hover:text-[#556B2F]' : 'text-[#5C6656]'}`}
          data-testid="language-switcher"
        >
          <Globe size={14} />
          <span className="text-sm">{current.flag} {current.label}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-40 p-1 border-[#E5E7E1]" align="end">
        {LANGS.map(lang => (
          <button
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            data-testid={`lang-${lang.code}`}
            className={`w-full flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors ${
              i18n.language === lang.code
                ? 'bg-[#E9EDDF] text-[#556B2F] font-medium'
                : 'text-[#5C6656] hover:bg-[#F9F8F6]'
            }`}
          >
            <span>{lang.flag}</span>
            <span>{lang.label}</span>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
